import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { getEntriesByIds } from 'b2b-apps/shop/content/redux/contentEntries/selectors';
import { ContentEntryType } from 'b2b-apps/shop/content/redux/contentEntries/types';

type UseEntriesReturnType = Array<RemoteRecord<ContentEntryType>>;

const useEntries = (entriesIds: string[]): UseEntriesReturnType => useSelector(
  useCallback((state: State) => getEntriesByIds(state, entriesIds), [entriesIds]),
);

export {
  useEntries,
};

export type {
  UseEntriesReturnType,
};
